// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlays the widget instead of replacing its content: taken out of flow, the
   panel can never change the widget's height, so opening it cannot reflow the
   host page or stretch a neighbouring card. The host widget container must be
   positioned. */
.info-panel {
  position: absolute;
  inset: 0;
  z-index: 2;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 24px;
  background-color: var(--surface-primary);
}

.info-panel-header {
  height: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.info-panel-title {
  min-width: 0;
  color: var(--text-primary);
}

.info-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.info-panel-close svg {
  width: 24px;
  height: 24px;
  display: block;
}

.info-panel-close svg path {
  fill: var(--text-primary);
}

.info-panel-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-top: 16px;
  padding-bottom: 8px;
  color: var(--text-primary);
  text-align: left;
}

/* body-m-regular, applied to every paragraph the caller passes in. */
.info-panel-body p {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  margin: 0 0 28px;
}

.info-panel-body p:last-child {
  margin-bottom: 0;
}

.info-panel-body p.info-panel-heading {
  font-weight: 700;
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/InfoPanel/InfoPanel.css"],"names":[],"mappings":"AAAA;;;gBAGgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* Overlays the widget instead of replacing its content: taken out of flow, the\n   panel can never change the widget's height, so opening it cannot reflow the\n   host page or stretch a neighbouring card. The host widget container must be\n   positioned. */\n.info-panel {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 0 24px;\n  background-color: var(--surface-primary);\n}\n\n.info-panel-header {\n  height: 42px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.info-panel-title {\n  min-width: 0;\n  color: var(--text-primary);\n}\n\n.info-panel-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.info-panel-close svg {\n  width: 24px;\n  height: 24px;\n  display: block;\n}\n\n.info-panel-close svg path {\n  fill: var(--text-primary);\n}\n\n.info-panel-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-top: 16px;\n  padding-bottom: 8px;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n/* body-m-regular, applied to every paragraph the caller passes in. */\n.info-panel-body p {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  margin: 0 0 28px;\n}\n\n.info-panel-body p:last-child {\n  margin-bottom: 0;\n}\n\n.info-panel-body p.info-panel-heading {\n  font-weight: 700;\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
